<template>
  <div>
    <MainMenuEntry
      v-for="entry in menuEntries"
      :key="entry.location.name"
      :location="entry.location"
      :icon-name="entry.iconName"
      :text="text[entry.location.name]"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { brelagMandatorRouteName } from '@/apps/brelag/mandator-admin/app'
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'

const menuEntries = computed(() => {
  return [
    {
      iconName: 'mdi-account',
      location: { name: brelagMandatorRouteName('profile-root') },
    },
    {
      iconName: 'mdi-cash',
      location: { name: brelagMandatorRouteName('webshop-root') },
    },
    {
      iconName: 'mdi-cloud-print-outline',
      location: { name: brelagMandatorRouteName('order-root') },
    },
  ]
})

const text = computed(() => {
  return {
    [brelagMandatorRouteName('profile-root')]: i18n.global.t(
      'apps.brelag.user',
      2
    ),
    [brelagMandatorRouteName('webshop-root')]: i18n.global.t(
      'apps.brelag.webshop',
      2
    ),
    [brelagMandatorRouteName('order-root')]: i18n.global.t(
      'apps.brelag.order',
      2
    ),
  }
})
</script>
